import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _map from 'lodash/map';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';

// Helpers
import { getFooterPropsForColumn, getFooterClassName } from './inputTableFooter.helpers';

// Styles
import s from './inputTableFooter.module.scss';
var DEFAULT_COLUMN_CONFIG = new ColumnConfig();
var InputTableFooter = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputTableFooter, _PureComponent);
  var _super = _createSuper(InputTableFooter);
  function InputTableFooter() {
    var _this;
    _classCallCheck(this, InputTableFooter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderFooterCell", function () {
      var columnConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COLUMN_CONFIG;
      var data = _this.props.data;
      var footerAccessor = columnConfig.getFooterAccessor();
      var value = footerAccessor(data);
      var footerProps = getFooterPropsForColumn(columnConfig, data);
      var footerClassName = getFooterClassName(columnConfig, footerProps);
      var footerWidth = columnConfig.getWidth();
      var footerWrapperClassName = cx(footerClassName, s.footerCell, _defineProperty({}, s.footerCell__expand, !footerWidth));
      return /*#__PURE__*/React.createElement("div", {
        className: footerWrapperClassName,
        style: {
          width: footerWidth
        }
      }, value);
    });
    return _this;
  }
  _createClass(InputTableFooter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        columns = _this$props.columns,
        footerClassName = _this$props.footerClassName;
      return /*#__PURE__*/React.createElement("div", {
        className: "flex ".concat(s.footer, " ").concat(footerClassName)
      }, _map(columns, this.renderFooterCell));
    }
  }]);
  return InputTableFooter;
}(PureComponent);
InputTableFooter.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  footerClassName: PropTypes.string
};
InputTableFooter.defaultProps = {
  data: EMPTY_ARRAY,
  columns: EMPTY_ARRAY,
  footerClassName: ''
};
export default InputTableFooter;